const configImages = "https://res.cloudinary.com/palnet/image/upload/v1/";

export default configImages;
